import { headerHeight } from './modules/headerHeight';
import { jqHeaderMenu } from './modules/jqHeaderMenu';
import { jsScroll } from './modules/jsScroll';
import { smoothScroll } from './modules/smoothScroll';
import { tabletViewport } from './modules/tabletViewport';
import { countNum } from './modules/countNum';
import { gaspScrolltrigger } from './modules/gaspScrolltrigger';
import { slider } from './modules/slider';
import { jqAccordion } from './modules/jqAccordion';

headerHeight();
jqHeaderMenu();
jsScroll();
smoothScroll();
tabletViewport();
countNum();
gaspScrolltrigger();
slider();
jqAccordion();